import { colors } from "./config";

export const Avatar = {
  baseStyle: {
    container: {
      bgColor: colors.brand.secondary.base,
      color: 'white',
      fontWeight: 600,
    },
  }
}
